import { TYPES } from "./default_bank.type";
import { limit, onSnapshot, orderBy, query, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getApiFunctions } from "store/bailiff/api";

const app = getApp();
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider
const allDefaultBankSub = [];
export const snapDefaultBank = (callback) => (dispatch) => {
  setDefaultBankAllSuccess(dispatch, null);
  const cRef = getRefs().bank;
  const uid = auth?.currentUser?.uid;
  const c0 = where("owner", "==", uid);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      setDefaultBankAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultBankSub.push(unsub);
};

export const unSnapDefaultBank = () => (dispatch) => {
  allDefaultBankSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultBankSub.length = 0;
};

//snap last bank.
const lastBankSub = [];
export const snapLastBank = () => (dispatch) => {
  setDefaultBankLastSuccess(dispatch, null);
  const cRef = getRefs().bank;
  const uid = auth?.currentUser?.uid;
  const c0 = where("owner", "==", uid);
  const c1 = orderBy("createAt", "desc");
  const c2 = limit(1);
  const qRef = query(cRef, c0, c1, c2);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot?.docs?.map((doc) => doc?.data());
      const detail = data?.length > 0 ? data[0] : null;
      setDefaultBankLastSuccess(dispatch, detail);
    }
  });

  lastBankSub.push(unsub);
};

export const unSnapLastBank = () => (dispatch) => {
  lastBankSub.forEach((subscriber) => {
    subscriber();
  });
  lastBankSub.length = 0;
};

// ========= cloud function =========//

export const cloudAddBank =
  ({ accountName, accountNumber, code }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().bank.bankAddAccount;
    const options = { accountName, accountNumber, code };
    functions(options)
      .then((res) => {
        console.log({ res });
        callback && callback({ status: 200 });
      })
      .catch((error) => {
        console.error("Error generating withdraw:", error);
        callback &&
          callback({
            status: 500,
            data: error?.message || "Please try again!",
          });
      });
  };

export const cloudDeleteBank =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().bank.bankDeleteAccount;
    const options = { id };
    console.log({ options });
    functions(options)
      .then((res) => {
        console.log({ res });
        callback && callback({ status: 200 });
      })
      .catch((error) => {
        console.error("Error generating withdraw:", error);
        callback &&
          callback({
            status: 500,
            data: error?.message || "Please try again!",
          });
      });
  };
// ========= local function =========//
export const setDefaultBankAll = (data, callback) => (dispatch) => {
  setDefaultBankAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBankOpenAdd = (data, callback) => (dispatch) => {
  setDefaultBankOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBankOpenEdit = (data, callback) => (dispatch) => {
  setDefaultBankOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBankSelected = (data, callback) => (dispatch) => {
  setDefaultBankSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBankSearch = (data, callback) => (dispatch) => {
  setDefaultBankSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultBankLast = (data, callback) => (dispatch) => {
  setDefaultBankLastSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultBankAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BANK_ALL,
    payload: data,
  });
};

const setDefaultBankOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BANK_OPEN_ADD,
    payload: data,
  });
};

const setDefaultBankOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BANK_OPEN_EDIT,
    payload: data,
  });
};

const setDefaultBankSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BANK_SELECTED,
    payload: data,
  });
};

const setDefaultBankSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BANK_SEARCH,
    payload: data,
  });
};

const setDefaultBankLastSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_BANK_LAST,
    payload: data,
  });
};
